import { createSlice } from '@reduxjs/toolkit'

export const commonSlice = createSlice({
    name: 'common',
    initialState: {
      isLoader: false,
      isStreamingStarted: false,
      sessionId: null,
      isSessionChange :false,
      visibleTooltip: null,
      showDeleteModal: false,
      faqFade : false,
      isWarning : false,
      iconShow:true,
      isTutorial:false,
      onboardCarouselFadeOut:false,
      isHistoryBtnActive:false,
      isTutoButnActive:false,
      isIconButnActive:false,
      isOnBoardHeader: false,
      archivecarouselModalOpen:false,
      openDltModal:false,
      tooltipFadeModal:false,
      setDeleteFade:false,
      promptHeights: 0,
      fromCloseHistory:false,
      onHistoryClick: false,
    },
    reducers: {
      setDeleteFade: (state, action) => {
        state.setDeleteFade = action.payload
      },
      iconShow: (state, action) => {
        state.iconShow = action.payload
      },
      loader: (state, action) => {
        state.isLoader = action.payload
      },
      isStreamingStarted: (state, action) => {
        state.isStreamingStarted = action.payload
      },
      session: (state, action) => {
        state.sessionId = action.payload        
      },
      sessionChange: (state, action) => {
        state.isSessionChange = action.payload       
      },
      visibleTooltip: (state, action) => {
        state.visibleTooltip = action.payload
      },
      showDeleteModal: (state, action) => {
        state.showDeleteModal = action.payload
      },
      faqFade: (state, action) => {
        state.faqFade = action.payload
      },
      isWarning: (state, action) => {
        state.isWarning = action.payload
      },
      onboardCarouselFadeOut: (state, action) => {
        state.onboardCarouselFadeOut = action.payload
      },
      isTutorial: (state, action) => {
        state.isTutorial = action.payload
      },
      isTutoButnActive: (state, action) => {
        state.isTutoButnActive = action.payload
      },
      isIconButnActive: (state, action) => {
        state.isIconButnActive = action.payload
      },
      isHistoryBtnActive: (state, action) => {
        state.isHistoryBtnActive = action.payload
      },
      isOnBoardHeader: (state, action) => {
        state.isOnBoardHeader = action.payload
      },
      fromCloseHistory: (state, action) => {
        state.fromCloseHistory = action.payload
      },
      openDltModal:(state,action) =>{
        state.openDltModal = action.payload
      },
      archivecarouselModalOpen: (state, action) => {
        state.archivecarouselModalOpen = action.payload
      },
      tooltipFadeModal: (state, action) => {
        state.tooltipFadeModal = action.payload
      },
      promptHeights: (state, action) => {
        state.tooltipFadeModal = action.payload
      },
      onHistoryClick: (state, action) => {
        state.onHistoryClick = action.payload
      },
    },
  })
  
  // Action creators are generated for each case reducer function
  export const { setDeleteFade, loader, isStreamingStarted, session, sessionChange, visibleTooltip, showDeleteModal, faqFade, isWarning, iconShow, onboardCarouselFadeOut,fromCloseHistory, isTutorial, isTutoButnActive, isIconButnActive, isHistoryBtnActive, isOnBoardHeader, openDltModal, archivecarouselModalOpen, tooltipFadeModal, promptHeights, onHistoryClick } = commonSlice.actions
  
  export default commonSlice.reducer
  
  
  
